import React, { useState, useRef } from "react";
import ColorPicker from "fantastic/components/common/ColorPicker";
import OutsideClickHandler from "react-outside-click-handler";

import FamilySettings from "./FamilySettings";
import SizeSettings from "./SizeSettings";
import TextStyleSettings from "./TextStyleSettings";
import connectProps from "fantastic/lib/connectProps";
import usedColors from "fantastic/lib/usedColors";
import classNames from 'classnames';

const Settings = props => {
  const { size, family, onlyColor, font_weight, font_style, text_decoration, strike_through } = props;

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const color = props.color.value || "transparent";
  const formGroup = useRef(null);
  const colorButtonEl = useRef(null);

  const optionClasses = () => {
    return classNames(
      { "btn-full-width": onlyColor }
    );
  };

  const openColorPicker = () => {
    const { scrollToIfNeeded } = props;
    setDisplayColorPicker(!displayColorPicker);
    if (scrollToIfNeeded) scrollToIfNeeded(formGroup.current);
  };

  const closeColorPicker = ({ target }) => {
    if (colorButtonEl.current.contains(target)) return;
    setDisplayColorPicker(false);
  };

  const renderColorButton = () => {
    return (
      <button
        className={`btn btn-form btn-color ${optionClasses()}`}
        onClick={openColorPicker}
        ref={colorButtonEl}
      >
        <span style={{ background: color }}></span>
      </button>
    );
  };

  const handleColorChange = color => {
    const {
      onChange,
      color: { field }
    } = props;
    const newValue = color.hex === "transparent" ? "" : color.hex;
    onChange(field, newValue);
  };
  const label = props.label || i18n.t('font');

  return (
    <div className="form-group" ref={formGroup}>
      <label>{label}</label>
      <div>
        <div className="fantastic-sidebar__btn-group-container">
          <div className="btn-group btn-group-block">
            {renderColorButton()}
            { family && <FamilySettings {...props} /> }
            { size && <SizeSettings {...props} /> }
          </div>
          <TextStyleSettings {...props} />
        </div>
        <OutsideClickHandler onOutsideClick={closeColorPicker}>
          {displayColorPicker && (
            <ColorPicker
              color={color}
              onChange={handleColorChange}
              presetColors={usedColors(props)}
            />
          )}
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default Settings;
